import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

const defaultDuration = 3000;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback(({
    message,
    type = 'info',
    duration = defaultDuration,
    onClose = null
  }) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type, duration, onClose }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter(t => t.id !== id));
      if (onClose) onClose();
    }, duration);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999 }}>
        {toasts.map(({ id, message, type }) => (
          <div key={id} style={{
            marginBottom: 12,
            padding: '12px 20px',
            borderRadius: 6,
            color: '#fff',
            background: type === 'success' ? '#52c41a' : type === 'error' ? '#ff4d4f' : type === 'warning' ? '#faad14' : '#1890ff',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            minWidth: 220,
            fontWeight: 500,
            fontSize: 15,
            transition: 'all 0.3s',
            cursor: 'pointer',
            opacity: 0.95
          }}>
            {message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};
